<template>
  <div>
    <div
      v-for="(subBlock, subBlockName) in dataBody"
      :key="subBlockName"
      class="ts-mb-10 tw-relative"
    >
      <div class="ts-mb-1 ts-w-full subblock-name">
        <span
          class="ts-text-lg ts-font-semibold text-blue subblock-name__text"
          >{{ subBlockName }}</span
        >
      </div>
    </div>
    <div>
      <table class="table table-bordered table-hover ui-table">
        <thead>
          <th class="ts-text-center">DESCRIPTION</th>
          <th class="ts-text-center" colspan="2">AMOUNT</th>
        </thead>
        <tbody>
          <tr v-for="(item, subBlock) in subBlock" :key="subBlock">
            <td class="ts-whitespace-no-wrap ts-text-gray-800 ts-font-semibold">
              {{ item.dispay_name }}
            </td>
            <td
              class="ts-whitespace-no-wrap ts-text-gray-700"
              style="width: 107px; text-align: right"
            >
              {{
                item.display_side === 'R' ? formatNumber(item.field_value) : ''
              }}
            </td>
            <td
              class="ts-whitespace-no-wrap ts-text-gray-700"
              style="width: 107px; text-align: right"
            >
              {{
                item.display_side === 'L' ? formatNumber(item.field_value) : ''
              }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  props: ['dataBody'],
  computed: {
    ...mapGetters(['formatNumber'])
  },
  methods: {
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(',', '.')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  }
}
</script>
<style lang="scss" scoped>
.subblock-name {
  &__text {
    padding: 0 0;
    display: inline-block;
  }
}
</style>
